// if (process.env.VUE_APP_CURRENTMODE == 'production') {
//   var targetProtocol = "https:";
//   if (window.location.protocol != targetProtocol) {
//     window.open(targetProtocol + window.location.href.substring(window.location.protocol.length), '_self');
//   }
// }
import Vue from "vue";
import animate from 'animate.css'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "babel-polyfill";
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/common/common.css";
import componentsPub from "@/components/public";
import commonHeader from "./components/common/commonHeader"
import VueParticles from 'vue-particles';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import puglin from "./lib/pulgin"
import GlobalConfig from "./lib/config"
import jquery from 'jquery';
Vue.use(VueParticles);
Vue.use(animate);
//按需引入element
import {
  Carousel,
  CarouselItem,
  Input,
  Icon,
  Button,
  Pagination,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Form,
  FormItem,
  Message,
  Upload,
  Dialog,
  Drawer,
  Popover,
  Checkbox,
  Select,
  Option,
  Tooltip
} from "element-ui";

//按需引入element
Vue.use(Button);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Input);
Vue.use(Icon);
Vue.use(Pagination);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Form);
Vue.use(FormItem);
Vue.component(Message);
Vue.use(Upload);
Vue.use(Dialog);
Vue.use(VueAwesomeSwiper);
Vue.use(Popover);
Vue.use(Drawer);
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Option);
Vue.use(Tooltip);
Vue.component("common-header",commonHeader)
Vue.prototype.$GlobalConfig = GlobalConfig;
Vue.prototype.$ajax = axios;
Vue.prototype.$message = Message;
window.$=jquery;
//去除警告！
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
